module.exports = __webpack_public_path__ + "static/me-01a5333778fbc1545216d214096d6bf8.jpg";